import { Box, Container } from '@mui/material';
import HeaderBreadcrumbs from 'src/components/header-bread-crumbs/HeaderBreadcrumbs';
import CNLoading from 'src/components/loading-cn/CNLoading';
import Page from 'src/components/page/page';
import Eventform from './components/event-form';
import useEventDetails from './event-details.hook';
import DaysModal from './components/days-modal';
import RegisterCpfs from '../products/details/components/cpf-modal';

export default function EventDetails() {
  const hook = useEventDetails();
  const {
    isEdit,
    isLoadingEventDetails,
    methods,
    fileName,
    days,
    values,
    isSubmitting,
    TIERS_OPTIONS,
    CATEGORIES_OPTIONS,
    SCHEDULE_LABEL,
    SCHEDULE_OPTIONS,
    AGE_OPTIONS,
    HIGHLIGHT_OPTIONS,
    open,
    id,
    cpfs,
    DONT_LABEL,
    DONT_OPTIONS,
    PRIVATE_LABEL,
    PRIVATE_OPTIONS,
    LIMITS_LABEL,
    LIMITS_OPTIONS,
    EXHIBITION_ENV_OPTIONS,
    hasCpfsToDownload,
    hasDaysToDownload,
    handleDownloadCpfs,
    handleDownloadDays,
    setOpenCpfs,
    onSubmit,
    handleDrop,
    handleDropMultiple,
    handleRemove,
    handleRemoveAll,
    setOpen,
    handleUpload,
  } = hook;
  return (
    <Page title={isEdit ? 'Editar Experiência' : 'Cadastrar Experiência'}>
      <Container maxWidth="lg">
        <HeaderBreadcrumbs
          heading={isEdit ? 'Editar Experiência' : 'Cadastrar Experiência'}
          links={[]}
        />
        {isLoadingEventDetails ? (
          <Box flexGrow={1} display="flex" justifyContent="center" alignItems="center" mt={30}>
            <CNLoading />
          </Box>
        ) : (
          <Eventform
            methods={methods}
            onSubmit={onSubmit}
            handleDrop={handleDrop}
            handleDropMultiple={handleDropMultiple}
            values={values}
            isEdit={isEdit}
            isSubmitting={isSubmitting}
            handleRemove={handleRemove}
            handleRemoveAll={handleRemoveAll}
            tierOptions={TIERS_OPTIONS}
            categoriesOptions={CATEGORIES_OPTIONS}
            scheduleOptions={SCHEDULE_OPTIONS}
            schedulelabel={SCHEDULE_LABEL}
            ageOptions={AGE_OPTIONS}
            optionsHighlight={HIGHLIGHT_OPTIONS}
            setOpen={setOpen}
            days={days}
            cpfs={cpfs}
            dontOptions={DONT_OPTIONS}
            dontlabel={DONT_LABEL}
            privateOptions={PRIVATE_OPTIONS}
            privatelabel={PRIVATE_LABEL}
            setOpenCpfs={setOpenCpfs}
            limitsOptions={LIMITS_OPTIONS}
            limitslabel={LIMITS_LABEL}
            exhibitionEnvOptions={EXHIBITION_ENV_OPTIONS}
            hasCpfsToDownload={hasCpfsToDownload}
            hasDaysToDownload={hasDaysToDownload}
            handleDownloadCpfs={handleDownloadCpfs}
            handleDownloadDays={handleDownloadDays}
          />
        )}
        <DaysModal
          fileName={fileName}
          handleUpload={handleUpload}
          onClose={() => setOpen(false)}
          open={open}
          scheduleType={values.scheduleType as any}
          eventId={id!}
          isEdit={isEdit}
        />
        <RegisterCpfs productDetailsHook={hook} />
      </Container>
    </Page>
  );
}
